import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import axios from "axios"; 

import "swiper/css";
import "swiper/css/pagination";
import { MyApi } from "../../MyApi";

export default function HomeTestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
         const res = await axios.get(
          MyApi.BASE_URL + MyApi.TESTIMONIAL_GET,
          {
            headers: { Authorization: MyApi.SECRET_KEY },
            params: { page: 1, limit: 4 },
          }
        );

        if (res.data.status && res.data.testimonials) {
          setTestimonials(res.data.testimonials);
        } else {
          setTestimonials([]);
        }
      } catch (err) {
        console.error("Failed to fetch testimonials:", err);
        setTestimonials([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  if (loading) {
    return <div>Loading testimonials...</div>;
  }

  if (testimonials.length === 0) {
    return <div>No testimonials available.</div>;
  }

  return (
    <div className="testmonialBx">
      <div className="container">
        <div className="heading_a">
          <span>Testimonials</span>
          <h3>What Customers Say About Us</h3>
        </div>

        <Swiper
         modules={[Autoplay, Pagination]}
        autoplay={{
          delay:2000,            // delay 0 for continuous movement
          disableOnInteraction: false,
          pauseOnMouseEnter: true, // optional, pause on hover
        }}
        loop={true}
        speed={4000}           // speed in ms, adjust for smoothness
        spaceBetween={20}
        slidesPerView={1}      // 1 slide at a time
        className="testimonialsSwiper"
              >
          {testimonials.map((t) => (
            <SwiperSlide key={t.id}>
              <div className="testimo_inn">
                {t.feedback} {/* yaha aap uname ya rating bhi dikha sakte ho */}
                <br />
                <strong>- {t.uname}</strong>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
